import deepmerge from 'deepmerge';
import { FlattenSimpleInterpolation } from 'styled-components';
import { Theme, renderFont } from '@empiriecom/module-components/ThemeProvider';
import config from '@/config';

export interface ProductSelectionTheme extends Theme {
  component: {
    productSelection: {
      color: {
        background: string;
        isSelected: string;
      };
      font: {
        family: FlattenSimpleInterpolation;
        size: string;
      };
    };
  };
}

// tslint:disable-next-line: arrow-return-shorthand
export const productSelectionTheme = (
  theme: Theme & Partial<ProductSelectionTheme>,
): ProductSelectionTheme => {
  let componentTheme = {
    color: {
      background: '#f4f4f4',
      isSelected:
        config.productSelection.borderColor === 'PRIMARY'
          ? theme.primary.color.normal
          : theme.base.color.text,
    },
    font: {
      family: renderFont('base', 'normal', theme),
      size: '0.75em',
    },
  };

  if (theme.component.productSelection) {
    componentTheme = deepmerge(componentTheme, theme.component.productSelection);
  }

  return {
    ...theme,
    component: {
      ...theme.component,
      productSelection: componentTheme,
    },
  };
};

export default productSelectionTheme;
